import { render, staticRenderFns } from "./QuestReport.vue?vue&type=template&id=2245af24&scoped=true&"
import script from "./QuestReport.vue?vue&type=script&lang=js&"
export * from "./QuestReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245af24",
  null
  
)

export default component.exports